<template>
   <!-- ======= Top Bar ======= -->
  <div id="topbar" class="d-flex align-items-center fixed-top">
    <div
      class="container d-flex align-items-center justify-content-center justify-content-md-between"
    >
      <div class="align-items-center d-none d-md-flex">
        سبلان میکسر | تولید کننده انواع میکسر بتن
      </div>
      <div class="d-flex align-items-center">
        <i class="bi bi-phone"></i>
        با مدیریت علی رضوانپور 09122982182
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>